var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { ESubProductIds } from "@frameworks/shared-library/components/Orderbook/common/OrderbookConstants";
import otcDi from "../../../../mainDi/features/OTC/servicelocator";
import { addCommasWithoutEffectingDecimals } from "@domains/utils/numberMethods";
import React, { useEffect, useMemo, useState } from "react";
import moment from "moment";
import { capitalizeFirstLetter } from "@frameworks/salesjourney/utils/genericMethods";
import { toCamelCase } from "@domains/utils/stringMethods";
import GenericSchemeName from "@frameworks/shared-library/components/GenericSchemeName/GenericSchemeName";
import { useColumnName } from "./useColumnName";
import "@frameworks/shared-library/stylesheets/components/NCD/product-bouquet.scss";
import { EKebebMenuItemsOTC, EOrderBookOrderBy, ERefundNameType, } from "@frameworks/NCD/Enum/OTC";
import OrderBookActions from "@redux/feature/Markets/NCD/actions/OrderBookActions";
import actions from "@redux/feature/Markets/NCD/actions/OrderBookActions";
import { getRefundTypes } from "@frameworks/NCD/Utils/getRefundTypes";
import { shouldCallApi } from "@frameworks/NCD/Utils/shouldCallApi";
import TooltipWrapper from "@frameworks/NCD/Components/Tooltip/TooltipWrapper";
import { nanoid } from "nanoid";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import { useSelector } from "react-redux";
var tempData = [
    {
        icon: "edel-icon-page-search",
        text: "View Details",
    },
];
var getSchemeValue = function (schemeValuesArr, schemeKeysArr, schemeKey) {
    var _a;
    return (_a = schemeValuesArr[schemeKeysArr.indexOf(schemeKey)]) !== null && _a !== void 0 ? _a : "";
};
export var useOrderBookTableColumns = function (subCategoryId, setOpenViewDetails, setFilterLabels, setSelectedValue, setSearchText) {
    var _a = __read(useState(null), 2), orderId = _a[0], setOrderId = _a[1];
    var _b = __read(useState(""), 2), type = _b[0], setType = _b[1];
    var _c = __read(useState(false), 2), isInitiateRefund = _c[0], setIsInitiateRefund = _c[1];
    var _d = __read(useState(""), 2), cancelOrder = _d[0], setCancelOrder = _d[1];
    var cActions = useMemo(function () { return new actions(); }, []);
    var cOrderBookActions = new OrderBookActions();
    var _e = __read(useState(false), 2), showInitiateRefundPopup = _e[0], setShowInitiateRefundPopup = _e[1];
    var _f = __read(useState(false), 2), loading = _f[0], setLoading = _f[1];
    var _g = __read(useState([]), 2), refundTypes = _g[0], setRefundTypes = _g[1];
    var _h = useSelector(function (state) { return state.markets.Otc.orderBookReducer; }), reduxSelectedRefundType = _h.selectedRefundType, selectedRefundReason = _h.selectedRefundReason;
    var _j = __read(useState({
        name: "",
        id: null,
        refund_description: "",
    }), 2), selectedRefundType = _j[0], setSelectedRefundType = _j[1];
    var _k = __read(useState({
        isShowPopup: false,
        containerId: "",
    }), 2), tableRowActionPopupConfig = _k[0], setTableRowActionPopupConfig = _k[1];
    var _l = __read(useState(false), 2), openSBViewDetails = _l[0], setOpenSBViewDetails = _l[1];
    var _m = __read(useState([]), 2), tableRowThreeDotActionPopupList = _m[0], setTableRowThreeDotActionPopupList = _m[1];
    var generateSchemeName = function (values) {
        var isNewScheme = getSchemeValue(values, values, values === null || values === void 0 ? void 0 : values[3]);
        var isFeaturedScheme = getSchemeValue(values, values, values === null || values === void 0 ? void 0 : values[2]);
        var generateWidthForCalc = function () {
            var maxWidth = 0;
            if (isFeaturedScheme) {
                maxWidth = 85;
            }
            if (isNewScheme) {
                maxWidth = 85;
            }
            if (isFeaturedScheme && isNewScheme) {
                maxWidth = 155;
            }
            return "calc(100% - ".concat(maxWidth, "px)");
        };
        return (React.createElement("div", { className: "otc-table-wrapper position-relative" },
            React.createElement("div", { className: "read-more-tooltip align-items-center scheme_name_wrap " },
                React.createElement(GenericSchemeName, { name: capitalizeFirstLetter(String(values[0])), subText1: String(values[1]), maxWidth: 300, maxWidthUnit: "px", showTooltip: true, showImage: true, parentClassName: "text-start w-100", tooltipPlacement: "top", tooltipClassName: "scheme-name-tooltip", subTextMaxWidth: generateWidthForCalc(), highlightSchemeNameOnHover: true }))));
    };
    var generateClientName = function (values) {
        var uniqueIdForTooltipContainer = nanoid();
        return (React.createElement("div", { className: "d-flex flex-column gap-1 client-data-wrapper" },
            !values[0] ? (React.createElement("span", { className: "txt-grey-shade1 client-name-wrapper DMSanN_16_400", title: values[0] }, values[0] ? toCamelCase(values[0]) : "-")) : (React.createElement(TooltipWrapper, { content: toCamelCase(values[0]), containerId: uniqueIdForTooltipContainer },
                React.createElement("div", { className: "txt-grey-shade1 client-name-wrapper DMSanN_16_400 text-truncate hand_cursor", title: values[0] }, values[0] ? toCamelCase(values[0]) : "-"))),
            React.createElement("span", { className: "txt-purple-navy RobotoM_14_300 fw-300" }, values[1] ? values[1] : "-")));
    };
    var generateStatus = function (Keys) {
        return (React.createElement("div", { className: "DMsanL_15_300 justify-content-start primary-generic-status-container d-flex align-items-center gap-5px", style: { color: "".concat(Keys[1]) } },
            React.createElement("i", { className: "edel-icon-round-circle", style: { color: "".concat(Keys[1]) } }),
            React.createElement("span", { className: "status-text" }, Keys[0])));
    };
    var generateDate = function (displayData) {
        var date = moment(displayData);
        var formattedDate = date.format("DD MMM YY");
        var formattedTime = date.format("hh:mm:ss A");
        return displayData ? (React.createElement("div", { className: "d-flex flex-column gap-1" },
            React.createElement("span", { className: "Roboto_16_400 txt-purple-navy" }, formattedDate ? formattedDate : "-"))) : ("-");
    };
    var generateAmount = function (key) {
        var _a;
        return key ? (React.createElement("div", { className: "d-flex flex-column gap-1" },
            React.createElement("span", { className: "Roboto_16_400 txt-purple-navy" }, (_a = addCommasWithoutEffectingDecimals(Number(key[0]))) !== null && _a !== void 0 ? _a : "-"),
            React.createElement("span", { className: "txt-grey-shade1 Roboto_16_400" }, "(".concat(addCommasWithoutEffectingDecimals(Number(key[1])), "/ qty)")))) : ("-");
    };
    var handleTableRowThreeDotsClick = function (keys, refundType, multiple) {
        return function (e) {
            e.stopPropagation();
            var alreadyAdded = tempData === null || tempData === void 0 ? void 0 : tempData.some(function (item) { return (item === null || item === void 0 ? void 0 : item.text) === "Initiate Refund"; });
            var alreadyCancelAdded = tempData === null || tempData === void 0 ? void 0 : tempData.some(function (item) { return (item === null || item === void 0 ? void 0 : item.text) === "Cancel"; });
            // Handle Initiate Refund CTA
            if ((refundType === null || refundType === void 0 ? void 0 : refundType.name) && (refundType === null || refundType === void 0 ? void 0 : refundType.id)) {
                if (!alreadyAdded) {
                    tempData.push({
                        icon: "edel-icon-refund-rupee txt_blackOne1",
                        text: "Initiate Refund",
                    });
                }
                cActions.updateIsRefundReasonSelected(multiple);
            }
            else {
                if (alreadyAdded) {
                    tempData = tempData.filter(function (item) { return (item === null || item === void 0 ? void 0 : item.text) !== "Initiate Refund"; });
                }
            }
            if (Number(keys[8]) === 0) {
                if (alreadyCancelAdded) {
                    tempData = tempData.filter(function (item) { return (item === null || item === void 0 ? void 0 : item.text) !== "Cancel"; });
                }
            }
            else {
                if (!alreadyCancelAdded) {
                    tempData.push({
                        icon: "edel-icon-cross",
                        text: "Cancel",
                    });
                }
            }
            setSelectedRefundType(refundType);
            var updatedTempData = tempData.map(function (item) { return (__assign(__assign({}, item), { containerId: "".concat(keys[0]).concat(subCategoryId) })); });
            setTableRowThreeDotActionPopupList(updatedTempData);
            setTableRowActionPopupConfig({
                isShowPopup: true,
                containerId: "".concat(keys[0]).concat(subCategoryId),
            });
            setOrderId(keys[0]);
            setType(keys[1]);
        };
    };
    var generateTableRowActionPopup = function (keys, refundType, multiple) {
        return (React.createElement("span", { id: "".concat(keys[0]).concat(subCategoryId), className: "edel-icon-kabab-menu mf-transactions-row-actions-wrapper position-relative ".concat(tableRowActionPopupConfig.containerId === "".concat(keys[0]).concat(subCategoryId)
                ? "active-menu"
                : ""), onClick: handleTableRowThreeDotsClick(keys, refundType, multiple) }));
    };
    var handleTableRowThreeDotsPopupClose = function () {
        setTableRowActionPopupConfig({
            isShowPopup: false,
            containerId: "",
        });
    };
    var fetchOrderBookDetails = function (orderId, type) { return __awaiter(void 0, void 0, void 0, function () {
        var err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    setLoading(true);
                    return [4 /*yield*/, otcDi.orderBook.getOrderBookDetails({
                            order_id: orderId,
                            buy_sell_flag: type.toUpperCase(),
                        })];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 2:
                    err_1 = _a.sent();
                    console.error("Error fetching order book details:", err_1);
                    return [3 /*break*/, 4];
                case 3:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleAllBondsThreeDotsMenuItemClick = function (item) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, res, _selectedRefundType;
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _a = item.text;
                    switch (_a) {
                        case EKebebMenuItemsOTC.CANCEL: return [3 /*break*/, 1];
                        case EKebebMenuItemsOTC.INITIATE_REFUND: return [3 /*break*/, 3];
                        case EKebebMenuItemsOTC.VIEW_DETAILS: return [3 /*break*/, 4];
                    }
                    return [3 /*break*/, 5];
                case 1:
                    setTableRowActionPopupConfig({
                        isShowPopup: false,
                        containerId: "",
                    });
                    return [4 /*yield*/, otcDi.orderBook.cancelOrder({
                            order_id: orderId,
                            buy_sell_flag: type.toUpperCase(),
                        })];
                case 2:
                    res = _d.sent();
                    if (((_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.status) === "SUCCESS") {
                        setCancelOrder((_c = res === null || res === void 0 ? void 0 : res.data) === null || _c === void 0 ? void 0 : _c.message);
                        setIsInitiateRefund(false);
                        if (subCategoryId === ESubProductIds.NCD) {
                            cActions.setOrderBookNcdRequestPayload({
                                category_code: Number(subCategoryId),
                                page_index: 1,
                                page_size: 10,
                                orderby: EOrderBookOrderBy.TRXDATE,
                                orderbydesc: true,
                                from_date: moment().startOf("month").format("YYYY-MM-DD"),
                                to_date: moment().endOf("month").format("YYYY-MM-DD"),
                            });
                        }
                        else {
                            cActions.setOrderBookRequestPayload({
                                category_code: Number(subCategoryId),
                                page_index: 1,
                                page_size: 10,
                                orderby: EOrderBookOrderBy.TRXDATE,
                                orderbydesc: true,
                                from_date: moment().startOf("month").format("YYYY-MM-DD"),
                                to_date: moment().endOf("month").format("YYYY-MM-DD"),
                            });
                        }
                    }
                    return [3 /*break*/, 5];
                case 3:
                    _selectedRefundType = __assign(__assign({}, selectedRefundType), { refund_description: "" });
                    cActions.updateSelectedRefundType(_selectedRefundType);
                    fetchOrderBookDetails(orderId, type.toUpperCase());
                    setOpenViewDetails(true);
                    setIsInitiateRefund(true);
                    return [3 /*break*/, 5];
                case 4:
                    fetchOrderBookDetails(orderId, type.toUpperCase());
                    setOpenViewDetails(true);
                    setIsInitiateRefund(false);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleAssignHandlerForThreeDotMenuItemClick = function (item) { return function (e) {
        e.stopPropagation();
        handleAllBondsThreeDotsMenuItemClick(item);
    }; };
    var columns = useMemo(function () {
        var generatedColumns = [
            {
                columnName: useColumnName(subCategoryId),
                keysForCustomFunction: ["display_name", "isin_code"],
                arrows: true,
                type: "string",
                applySorting: true,
                sortKey: "display_name",
                tdCustomFunction: generateSchemeName,
            },
            {
                columnName: "Client Name",
                keysForCustomFunction: ["ac_name", "pan"],
                type: "string",
                applySorting: true,
                sortKey: "ac_name",
                arrows: true,
                tdCustomFunction: generateClientName,
                arrowClassName: "justify-content-start",
                columnClassName: "text-start DMSansMedium_12_500",
            },
            {
                columnName: "Type",
                keysForCustomFunction: ["order_type"],
                type: "string",
                applySorting: true,
                sortKey: "type",
                arrows: true,
                arrowClassName: "justify-content-start",
                columnClassName: "text-start DMSansMedium_12_500",
                tdCustomFunction: function (keys) { return (React.createElement("div", { className: "d-flex flex-column gap-1 txt_medium-gray DMSanN_16_400" }, keys[0].charAt(0).toUpperCase() + keys[0].slice(1).toLowerCase())); },
            },
            {
                columnName: "Quantity",
                keysForCustomFunction: ["quantity"],
                type: "string",
                applySorting: true,
                sortKey: "quantity",
                arrows: true,
                arrowClassName: "justify-content-end",
                columnClassName: "text-end DMSansMedium_12_500",
                tdCustomFunction: function (keys) {
                    var _a;
                    return (React.createElement("div", { className: "d-flex flex-column gap-1 txt-purple-navy Roboto_16_400" }, (_a = keys[0]) !== null && _a !== void 0 ? _a : "--"));
                },
            },
            {
                columnName: "Amount (₹)",
                keysForCustomFunction: ["amount", "price_per_qty"],
                type: "string",
                applySorting: true,
                arrows: true,
                sortKey: "amount",
                arrowClassName: "justify-content-end",
                columnClassName: "text-end DMSansMedium_12_500",
                tdCustomFunction: generateAmount,
            },
            {
                columnName: "Date",
                key: "trx_date",
                type: "Date",
                applySorting: true,
                sortKey: "trx_date",
                arrows: true,
                tdCustomFunction: generateDate,
                arrowClassName: "justify-content-end",
                columnClassName: "text-end DMSansMedium_12_500",
            },
            {
                columnName: (React.createElement("div", { className: "d-flex align-items-center gap-1 justify-content-end" }, "Status")),
                keysForCustomFunction: ["order_status", "status_colour"],
                key2: "order_status",
                arrows: false,
                type: "string",
                arrowClassName: "text-start",
                columnClassName: "DMSansMedium_12_500 text-start",
                tdCustomFunction: function (key) { return generateStatus(key); },
            },
            {
                columnName: "",
                keysForCustomFunction: [
                    "order_id",
                    "type",
                    "refund_cancelled_rejected_id",
                    "refund_cancelled_rejected_type",
                    "refund_excessfunds_id",
                    "refund_excessfunds_type",
                    "refund_interest_dividend_id",
                    "refund_interest_dividend_type",
                    "is_cancel",
                ],
                arrowClassName: "justify-content-start",
                columnClassName: "text-start DMSansMedium_12_500",
                tdCustomFunction: function (key) {
                    var data = getRefundTypes({
                        refund_cancelled_rejected_id: key[2],
                        refund_cancelled_rejected_type: key[3],
                        refund_excessfunds_id: key[4],
                        refund_excessfunds_type: key[5],
                        refund_interestdividend_id: key[6],
                        refund_interestdividend_type: key[7],
                    });
                    var multiple = data.length > 1 ? true : false;
                    return (reduxSelectedRefundType === null || reduxSelectedRefundType === void 0 ? void 0 : reduxSelectedRefundType.id) ? (React.createElement(EdButton, { btnTyp: "tomato-rounded", value: "Initiate Refund", onClick: function (e) {
                            e === null || e === void 0 ? void 0 : e.stopPropagation();
                            fetchOrderBookDetails(Number(key[0]), key[1].toUpperCase());
                            setOpenViewDetails(true);
                            setIsInitiateRefund(true);
                            cActions.updateSelectedRefundType(__assign(__assign({}, data === null || data === void 0 ? void 0 : data[0]), { refund_description: "" }));
                            cActions.updateSelectedRefundReason(__assign(__assign({}, data === null || data === void 0 ? void 0 : data[0]), { refund_description: "" }));
                            setOrderId(key[0]);
                            setType(key[1]);
                            cActions.updateIsRefundReasonSelected(multiple);
                            setSelectedRefundType(data === null || data === void 0 ? void 0 : data[0]);
                        }, className: "invest-button text-nowrap DMsanL_15_300 mgr-22 width-126 height-32  me-0", hoverType: "tomato-rounded-background" })) : (generateTableRowActionPopup(key, data === null || data === void 0 ? void 0 : data[0], multiple));
                },
            },
        ];
        var nonClientNameColumns = generatedColumns.filter(function (col) {
            return typeof col.columnName !== "string" || col.columnName !== "Client Name";
        });
        if ([].includes(subCategoryId)) {
            return nonClientNameColumns;
        }
        return generatedColumns;
    }, [subCategoryId, selectedRefundReason === null || selectedRefundReason === void 0 ? void 0 : selectedRefundReason.id]);
    useEffect(function () {
        fetchRefundTypes();
    }, [subCategoryId]);
    var fetchRefundTypes = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, otcDi.orderBook.refundType({
                            category_code: Number(subCategoryId),
                        })];
                case 1:
                    response = _a.sent();
                    setRefundTypes(response.data);
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleRefundAction = function (item) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!((item === null || item === void 0 ? void 0 : item.name) === ERefundNameType.Suspense)) return [3 /*break*/, 1];
                    setIsInitiateRefund(true);
                    setOpenViewDetails(true);
                    cOrderBookActions.updateSelectedRefundType(item);
                    return [3 /*break*/, 3];
                case 1:
                    if (!shouldCallApi({
                        category_code: Number(subCategoryId),
                        page_index: 1,
                        page_size: 10,
                        orderby: EOrderBookOrderBy.TRXDATE,
                        orderbydesc: true,
                        from_date: moment().startOf("month").format("YYYY-MM-DD"),
                        to_date: moment().format("YYYY-MM-DD"),
                        refund_type: item === null || item === void 0 ? void 0 : item.id,
                    })) return [3 /*break*/, 3];
                    cOrderBookActions.setOrderBookRequestPayload({
                        category_code: Number(subCategoryId),
                        page_index: 1,
                        page_size: 10,
                        orderby: EOrderBookOrderBy.TRXDATE,
                        orderbydesc: true,
                        from_date: moment().startOf("month").format("YYYY-MM-DD"),
                        to_date: moment().format("YYYY-MM-DD"),
                        refund_type: item === null || item === void 0 ? void 0 : item.id,
                    });
                    return [4 /*yield*/, cOrderBookActions.updateSelectedRefundType(item)];
                case 2:
                    _a.sent();
                    cOrderBookActions.updateSelectedRefundReason(item);
                    setFilterLabels([]);
                    setSelectedValue({});
                    setSearchText("");
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return {
        columns: columns,
        tableRowActionPopupConfig: tableRowActionPopupConfig,
        setTableRowActionPopupConfig: setTableRowActionPopupConfig,
        tableRowThreeDotActionPopupList: tableRowThreeDotActionPopupList,
        setTableRowThreeDotActionPopupList: setTableRowThreeDotActionPopupList,
        handleTableRowThreeDotsPopupClose: handleTableRowThreeDotsPopupClose,
        handleAssignHandlerForThreeDotMenuItemClick: handleAssignHandlerForThreeDotMenuItemClick,
        openSBViewDetails: openSBViewDetails,
        setOpenSBViewDetails: setOpenSBViewDetails,
        isInitiateRefund: isInitiateRefund,
        setIsInitiateRefund: setIsInitiateRefund,
        showInitiateRefundPopup: showInitiateRefundPopup,
        setShowInitiateRefundPopup: setShowInitiateRefundPopup,
        refundTypes: refundTypes,
        handleRefundAction: handleRefundAction,
        loading: loading,
        cancelOrder: cancelOrder,
        setCancelOrder: setCancelOrder,
    };
};
